const moduleName = require('../../datashop.json').name;
const appConfig = datashop.app.module('getPublicConfig')(moduleName);
const { hostUrl } = appConfig;
const appBase = hostUrl + '/' + moduleName;

// https://webpack.js.org/guides/public-path/#set-value-on-the-fly

__webpack_public_path__ = `${appBase}/assets/`;
import App from './app';

class Root extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.render();
  }

  disconnectedCallback() {
    ReactDOM.unmountComponentAtNode(this);
  }

  attributeChangedCallback() {
    console.log('attribute change logged');
  }

  render() {
    ReactDOM.render(<App componentName={this.attributes.componentName.value} />, this);
  }
}

// define only if element is not available already
if (!customElements.get(moduleName)) {
  customElements.define(moduleName, Root);
}

export default Root;
